import { lazy, Suspense } from 'react';
import type { RichTextItem, TableItem, TodoItem } from '../../doc/schema';

const RichTextBodyImpl = lazy(() => import('./RichTextBodyImpl').then((m) => ({ default: m.RichTextBodyImpl })));

/** Rich blocks load the editor chunk on first use; until then the block is an empty box. */
export function RichTextBody({ item }: { item: RichTextItem | TableItem | TodoItem }) {
  return (
    <Suspense fallback={<div className={`richtext richtext-${item.type}`} style={{ background: item.props.bg ?? undefined }} />}>
      <RichTextBodyImpl item={item} />
    </Suspense>
  );
}
